import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts/fonts.css";
import "./index.css";
import "./i18n";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register the service worker so Co Stock is installable on iPhone/Android home screens.
// Only in production builds — a SW in the hot-reload dev/preview server serves stale bundles.
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    // Ensure no stale dev SW keeps controlling the preview.
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  }
}
